import { render } from "./TrustProfileOverviewDashboard.vue?vue&type=template&id=d6cbaef8&scoped=true"
import script from "./TrustProfileOverviewDashboard.vue?vue&type=script&lang=js"
export * from "./TrustProfileOverviewDashboard.vue?vue&type=script&lang=js"

import "./TrustProfileOverviewDashboard.vue?vue&type=style&index=0&id=d6cbaef8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cbaef8"]])

export default __exports__